module.exports = __webpack_public_path__ + "68148835ed65465c47c896ea68d0c185.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1148
// module chunks = 0